import { TipoDeCliente, TipoDeDoc, Sexo } from "../../../isp.žapi.clientes/constantesApiClientes";

const tiposCliente = [
    { label: "Con Doc. de Identidad", value: TipoDeCliente.DocId },
    // { label: "Con RUC", value: TipoDeCliente.RUC },
];

const tiposDoc = [
    { label: "DNI", value: TipoDeDoc.DNI },
    { label: "Pasaporte", value: TipoDeDoc.PASSPORT },
    { label: "PTP", value: TipoDeDoc.PERMISO_TEMP_PERM },
    { label: "Carnet de Extranjería", value: TipoDeDoc.CARNET_EXT },
];

const tiposSexo = [
    { label: "Masculino", value: Sexo.Masculino },
    { label: "Femenino", value: Sexo.Femenino },
];

const modosCobro = [
    { label: "Exonerado", value: "exo" },
    { label: "Cliente", value: "cliente" },
];
const tiposComprobantes = [
    { label: "Recibo de Venta", value: "rv" },
    { label: "Factura", value: "fac" },
    { label: "Boleta", value: "bol" },
];
const ciclosFact = [
    { label: "15 del mes", value: "15m" },
    { label: "Último dia del mes", value: "udiam" },
];

export { tiposCliente, tiposDoc, tiposSexo, modosCobro, tiposComprobantes, ciclosFact };
